/**
 * Moved to `shared/src/review/rank-driven-section-gaps.ts` so the review surface and the server-side
 * export read one copy of this logic. Edit it there.
 *
 * Named rather than `export *`: the Vite dev server's CommonJS interop runs a
 * star re-export before the module it re-exports has loaded.
 */
export {
  MAX_GAPS_RETURNED,
  MAX_RIVAL_POSITION,
  MIN_POSITION_DELTA,
  MIN_SEARCH_VOLUME,
  buildFocalCoverageLine,
  buildSectionGapVerdict,
  computeRankDrivenSectionGaps,
  dedupeRankGapVariants,
  enrichRankDrivenGapsFocalComparison,
  enrichRankDrivenGapsWithPassageEvidence,
  extractRankedKeywordsFromAnalysis,
  rankDrivenGapsForV2Row
} from '@taptimize/shared/dist/review/rank-driven-section-gaps';
export type {
  ComputeRankDrivenSectionGapsInput,
  RankDrivenSectionGap,
  RankedKeywordEntry,
  SectionGapOutlook,
  SectionGapVerdict
} from '@taptimize/shared/dist/review/rank-driven-section-gaps';
